
import React from 'react';
import _ from "lodash";

import NavBtnWidget from '../NavBtnWidget.jsx';

import {
    InputWidget,
    fromLabelValueCb, toLabelValueCb,
    SingleSelectWidget, MultiSelectWidget,
    DateInputWidget
} from '../../controls/widgets.jsx';

import { useStore } from '@nanostores/react';
import { $grades, $stdEducationDocumentTypes, $stdLanguages } from '../../stores/Dictionaries.jsx';


export default ({schema, data, onDataChanged}) => {
    const 
        onDataChangeEventHandler = (value, key) => {
            const diff = {};
            diff[key] = value;
            (onDataChanged || function(){})(diff);
        },
        //
        grades = useStore($grades),
        stdEducationDocumentTypes = useStore($stdEducationDocumentTypes),        
        stdLanguages = useStore($stdLanguages),
        //
        prioritySum = data.education_prio_subject_sum,
        avgGrade = data.education_avg_grade;

        return (
            <form className="form">
                <div className="card border-primary">
                    <div className="card-header text-bg-primary">Сведения об образовании</div>
                    <div className="card-body">

                        <div className="row">
                            <div className="col-md-12">
                                <InputWidget
                                    name="education_org"
                                    title="Общеобразовательное учреждение:"
                                    placeholder="название школы, вида МОУ СОШ № 999"
                                    vertical={true}
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-3">
                                <SingleSelectWidget
                                    name="education_document_type"
                                    title="Вид документа:"
                                    options={stdEducationDocumentTypes}
                                    cbFromData={fromLabelValueCb}
                                    cbToData={toLabelValueCb}
                                    vertical={true}
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler}
                                />
                            </div>
                            <div className="col-md-4">
                                <InputWidget
                                    name="education_document_number"
                                    title="Серия, номер документа:"
                                    vertical={true}
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler}
                                />
                            </div>
                            <div className="col-md-3">
                                <DateInputWidget
                                    name="education_document_issue_date"
                                    title="Дата выдачи:"
                                    vertical={true}
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler}
                                    />
                            </div>
                            <div className="col-md-2">
                                <InputWidget
                                    type="checkbox"
                                    name="education_document_red"
                                    title="Медаль"
                                    vertical={true}
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler}
                                    />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <MultiSelectWidget
                                    name="education_languages"
                                    title="Иностранные языки:"
                                    placeholder="Укажите языки, изученные вами в школе"
                                    cbFromData={fromLabelValueCb}
                                    cbToData={toLabelValueCb}
                                    vertical={true}
                                    options={stdLanguages}
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler}
                                    />
                            </div>

                        </div>

                    </div>
                </div>

                <div className="card border-primary mt-2">
                    <div className="card-header text-bg-primary">
                        Успеваемость по приоритетным предметам
                        &nbsp;
                        {(!isNaN(prioritySum) && prioritySum > 0) ? (<span className="badge">&sum; = {prioritySum}</span>) : null}
                    </div>
                    <div className="card-body form-horizontal">
                        <div className="row">
                            {_.map(data.education_prio_subjects, function (v, k) {
                                return (
                                    <div className="col-md-4" key={k}>
                                        <div className="col-md-12">
                                            <SingleSelectWidget
                                                name={"education_prio_subjects[" + k + "].value"}
                                                title={v.title}
                                                options={grades}
                                                cbFromData={fromLabelValueCb}
                                                cbToData={toLabelValueCb}
                                                vertical={true}
                                                validators={schema.child('education_prio_subjects', v, data).child('value', v, data)}
                                                data={data}
                                                value={v}
                                                onChange={onDataChangeEventHandler}
                                            />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                <div className="card border-primary mt-2">
                    <div className="card-header text-bg-primary">
                        Средний балл по всему аттестату
                        &nbsp;
                        {(!isNaN(avgGrade) && avgGrade > 0) ? <span className="badge">&alpha;={avgGrade}</span> : null}
                    </div>
                    <div className="card-body form-horizontal">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="col-md-12">
                                    <InputWidget
                                        name="education_count_5"
                                        title="Количество &laquo;5&raquo;:"
                                        vertical={true}
                                        schema={schema}
                                        data={data}
                                        onChange={onDataChangeEventHandler}
                                    />

                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="col-md-12">
                                    <InputWidget
                                        name="education_count_4"
                                        title="Количество &laquo;4&raquo;:"
                                        vertical={true}
                                        schema={schema}
                                        data={data}
                                        onChange={onDataChangeEventHandler}
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="col-md-12">
                                    <InputWidget
                                        name="education_count_3"
                                        title="Количество &laquo;3&raquo;:"
                                        vertical={true}
                                        schema={schema}
                                        data={data}
                                        onChange={onDataChangeEventHandler}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <NavBtnWidget to="/parents" />

            </form>
        );
    };